var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeWithEyelashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 122,
    viewBox: "0 0 150 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9992 113.596C92.9987 113.596 107.59 99.0009 107.59 80.9973C107.59 62.9938 92.9987 48.399 74.9992 48.399C56.9997 48.399 42.4082 62.9938 42.4082 80.9973C42.4082 99.0009 56.9997 113.596 74.9992 113.596Z",
    fill: "#ABDAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4702 109.223C59.4761 109.223 44.8792 94.6347 44.8792 76.6252C44.8792 71.6981 45.9777 67.0315 47.9368 62.8406C44.4489 68.0282 42.4219 74.2692 42.4219 80.9973C42.4219 98.9954 57.0074 113.596 75.0128 113.596C88.0809 113.596 99.3485 105.893 104.546 94.7819C98.6917 103.492 88.7604 109.223 77.4815 109.223H77.4702Z",
    fill: "#74B9C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.193 80.8387C114.193 102.484 96.6514 120.04 74.9996 120.04C53.3478 120.04 35.8066 102.495 35.8066 80.8387C35.8066 59.182 53.3478 41.637 74.9996 41.637C96.6514 41.637 114.193 59.25 114.193 80.8387Z",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0013 95.2576C82.8753 95.2576 89.2584 88.873 89.2584 80.9973C89.2584 73.1215 82.8753 66.7369 75.0013 66.7369C67.1273 66.7369 60.7441 73.1215 60.7441 80.9973C60.7441 88.873 67.1273 95.2576 75.0013 95.2576Z",
    fill: "#314C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1137 68.6059C86.5736 67.0655 84.0823 67.0655 82.5535 68.6059C81.0134 70.1463 81.0134 72.6382 82.5535 74.1673C84.0936 75.6964 86.5849 75.7077 88.1137 74.1673C89.6538 72.6269 89.6538 70.135 88.1137 68.6059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13281 71.5622C19.2402 56.3278 51.2083 33.4138 74.8645 33.4138C98.5207 33.4138 130.84 56.4297 148.857 71.5508",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.772 77.622C145.765 79.287 145.765 82.3452 143.772 84.0216C132.573 93.4227 98.4756 120.301 74.9553 120.301C51.435 120.301 17.4058 93.4114 6.2402 84.0102C4.25847 82.3452 4.25847 79.287 6.2402 77.622C17.4058 68.2321 51.4237 41.3425 74.9553 41.3425C98.4869 41.3425 132.573 68.2208 143.772 77.622Z",
    stroke: "#314C7E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7569 61.5381L4.3125 49.0107",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1472 49.0108L17.3125 24.9982",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.998 33.2439V1.13269",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6222 38.4881L46.7109 24.3297",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.229 61.5381L145.684 49.0107",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.838 49.0107L132.673 24.998",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.375 38.4881L103.286 24.3297",
    stroke: "#314C7E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 122,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWithEyelashes);
export default __webpack_public_path__ + "static/media/eye-with-eyelashes.f4b6df0c271053ef9262cd4fb5237d22.svg";
export { ForwardRef as ReactComponent };